<template>
    <v-card class="mt-5 mb-5">
        <v-card-title class="subtitle-1 font-weight-bold grey lighten-4">
            <template> {{ title }} </template>
        </v-card-title>
        <v-card-text>
            <v-data-table :headers="headers" :items="items" hide-default-footer class="elevation-1 compact-table">
                <template v-slot:items="{ item }">
                    <tr>
                        <td class="text-xs-center">{{ item.stt }}</td>
                        <td class="text-xs-center">{{ item.building }}</td>
                        <td class="text-xs-center">{{ item.room }}</td>
                        <td class="text-xs-center">{{ item.previous_month_consumption }}</td>
                        <td class="text-xs-center">{{ item.consumption }}</td>
                        <td class="text-xs-center">{{ item.average_consumption }}</td>
                        <td class="text-xs-center">
                            <v-edit-dialog
                                :return-value.sync="item.reason"
                                @save="$emit('update-notes', item, item.reason)"
                                @cancel="item.reason = item.notes"
                                large
                                @keydown.enter.native.stop.prevent="$emit('update-notes', item, item.reason)"
                            >
                                <span>{{ item.reason }}</span>
                                <template v-slot:input>
                                    <v-text-field v-model="item.reason" label="Giải thích" single-line @keydown.enter.stop.prevent="$emit('update-notes', item, item.reason)" />
                                </template>
                            </v-edit-dialog>
                        </td>
                        <td class="text-xs-center">{{ item.quantity }}</td>
                        <td class="text-xs-center">{{ item.equipment }}</td>
                    </tr>
                </template>
                <template v-slot:no-data>
                    Không có dữ liệu
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'table-phan-tich-dien-nuoc-chi-tiet',
    props: {
        headers: {
            type: Array,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            required: true
        }
    },
};
</script>

<style scoped>
.compact-table.v-data-table th,
.compact-table.v-data-table td {
    padding: 4px 8px !important;
    height: auto !important;
    font-size: 0.8rem;
}

.v-card-title {
    padding: 8px 16px;
    font-size: 0.95rem;
}

.text-xs-center {
    text-align: center;
}

.text-xs-right {
    text-align: right;
}
</style>